import React, {useContext} from "react";
import {Paper} from "@material-ui/core";
// Data
import {store} from "./store.js";
// Components
import Lookup from "./components/Lookup";
import Payment from "./components/Payment";
import Amount from "./components/Amount";
import Complete from "./components/Complete";
import Failed from "./components/Failed";
import Status from "./Status";
// Styles
import StyledApp from "./styles/App";
import Controls from "./styles/Controls";

const App = () => {
    const globalState = useContext(store);
    const state = globalState.state;

    const displayControls = () => {
        if (state.progress === "failed") {
            return <Failed/>;
        } else if (state.progress === "complete") {
            return <Complete/>;
        } else if (state.progress === "payment") {
            return <Payment/>;
        } else if (state.progress === "amount") {
            return <Amount/>;
        } else if (state.progress === "lookup") {
            return <Lookup/>;
        }
    };

    const showAccountDetails = () => {
        if (state.progress === "amount" || state.progress === "payment") {
            return <Status/>;
        }
    };

    return (
        <StyledApp>
            <div className="columns">
                <Controls>
                    <Paper className="control-container">
                        {displayControls()}
                    </Paper>
                </Controls>
                <div className="status-container">
                    {showAccountDetails()}
                </div>
            </div>
        </StyledApp>
    );
};

export default App;
